<script>
export default {
  name: "Logo",
};
</script>

<template>
  <div class="logo">
    <router-link class="link" :to="{ name: 'home' }">
      <img
        class="desktop"
        width="180"
        height="180"
        src="@/assets/logo-large.png"
        alt="Logotype"
      />

      <img
        class="mobile"
        width="60"
        height="60"
        src="@/assets/logo-small.png"
        alt="Logotype"
      />
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.logo {
  position: fixed;
  top: $space-small;
  left: $space-small;
  z-index: 997;
  width: 60px;
  height: 60px;
  opacity: 0.8;

  @include medium {
    top: $space-base;
    left: $space-base;
    width: 180px;
    height: 180px;
  }

  .link {
    display: block;
  }

  .mobile {
    @include medium {
      display: none;
    }
  }

  .desktop {
    display: none;

    @include medium {
      display: block;
    }
  }
}
</style>
